import BlackjackEngine from "@blackjacktrainer/blackjack-engine";

const settings = {
  animationDelay: 200,
  allowSurrender: false,
  allowLateSurrender: false,
  checkDeviations: false,
  gameMode: "default",
  cardCounterType: null
};

const game = new BlackjackEngine(settings);

export default game;



// WEBPACK FOOTER //
// ./src/game.js